import dynamic from 'next/dynamic';
import { type FC } from 'react';

import { FeatureFlagId } from '@craft/feature-flags';

import { HasFeatureFlag } from '@/src/features/integrations/statsig/components/HasFeatureFlag';
import { useIsIdle } from '@/src/hooks/use-is-idle';

import { type PostLoginClientDialogProps } from './PostLoginClientDialog';

const PostLoginClientDialog = dynamic(
  () => import('./PostLoginClientDialog').then(mod => mod.PostLoginClientDialog),
  { ssr: false },
);

export interface PostLoginDialogProps extends PostLoginClientDialogProps {}

const IdledPostLoginDialog: FC<PostLoginDialogProps> = props => {
  /**
   * Rendering the dialog mounts the dynamically imported client dialog, the profile-completeness
   * query and the PactSafe ({@link PSClickWrap}) policy fetch. None of that is needed for the
   * initial render, so it is deferred until the browser is idle to keep those requests off the
   * critical load path.
   */
  const isIdle = useIsIdle();

  if (isIdle) {
    return <PostLoginClientDialog {...props} />;
  }
  return null;
};

export const PostLoginDialog: FC<PostLoginDialogProps> = props =>
  process.env.NODE_ENV === 'test' ? null : (
    <HasFeatureFlag
      flag={{ any: [FeatureFlagId.InterruptionDialogFlow, FeatureFlagId.PolicyAcceptanceFlow] }}
    >
      <IdledPostLoginDialog {...props} />
    </HasFeatureFlag>
  );
